import * as types from 'manuals/actions/types';
import {apiAction} from 'apa/actions';
import {ENDPOINT_MANUAL_CATEGORY_URL} from 'manuals/actions/index';
import {loadManualList} from 'manuals/actions/manual';

export const loadCategoryList = () => dispatch => {
    dispatch({type: types.LOAD_MANUAL_CATEGORIES})
    dispatch(apiAction({
        url: ENDPOINT_MANUAL_CATEGORY_URL,
        onSuccess: categoryList => ({
            type: types.LOAD_MANUAL_CATEGORIES_SUCCESS,
            categoryList: categoryList
        }),
        onFailure: errors => ({
            type: types.LOAD_MANUAL_CATEGORIES_ERROR,
            errors: errors
        })
    }))
}
export const selectCategory = (category) => (dispatch, getState) => {
    const currentCategory = getState().manuals.selectedCategory
    if (currentCategory && currentCategory.id === category.id) {
        dispatch({
            type: types.SELECT_MANUAL_CATEGORY,
            selectedCategory: null
        })
    } else {
        dispatch({
            type: types.SELECT_MANUAL_CATEGORY,
            selectedCategory: category
        })
        dispatch(loadManualList(category))
    }
}
export const deselectCategory = () => dispatch =>
    dispatch({
        type: types.DESELECT_MANUAL_CATEGORY
    })
export const createCategory = (category) => dispatch => {
    dispatch({type: types.CREATE_MANUAL_CATEGORY})
    dispatch(apiAction({
        url: ENDPOINT_MANUAL_CATEGORY_URL,
        method: 'POST',
        data: category,
        onSuccess: newCategory => {
            dispatch(loadCategoryList())
            dispatch(selectCategory(newCategory))
            return {
                type: types.CREATE_MANUAL_CATEGORY_SUCCESS
            }
        },
        onFailure: errors => ({
            type: types.CREATE_MANUAL_CATEGORY_ERROR,
            errors: errors
        })
    }))
}
export const updateCategory = (category) => dispatch =>
    dispatch({type: types.UPDATE_MANUAL_CATEGORY, category: category})
export const saveCategory = (category) => dispatch => {
    dispatch({type: types.UPDATE_MANUAL_CATEGORY})
    dispatch(apiAction({
        url: `${ENDPOINT_MANUAL_CATEGORY_URL}${category.id}/`,
        method: 'PATCH',
        data: category,
        onSuccess: category => {
            dispatch(loadCategoryList())
            dispatch(selectCategory(category))
            return {
                type: types.SAVE_MANUAL_CATEGORY_SUCCESS
            }

        },
        onFailure: errors => ({
            type: types.SAVE_MANUAL_CATEGORY_ERROR,
            errors: errors
        })
    }))
}
export const deleteCategory = (category) => dispatch => {
    dispatch({type: types.DELETE_MANUAL_CATEGORY})
    dispatch(apiAction({
        url: `${ENDPOINT_MANUAL_CATEGORY_URL}${category.id}/`,
        method: 'DELETE',
        onSuccess: () => {
            dispatch(loadCategoryList())
            return {
                type: types.DELETE_MANUAL_CATEGORY_SUCCESS
            }
        },
        onFailure: errors => ({
            type: types.DELETE_MANUAL_CATEGORY_ERROR,
            errors: errors
        })
    }))
}
